import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { useWalletInterface } from "../services/wallets/useWalletInterface";
import SearchIcon from '@mui/icons-material/Search';
import DrawIcon from '@mui/icons-material/Draw';
import { useState } from "react";
import { networkConfig } from "../config/networks";

export default function Home() {
  const { walletInterface } = useWalletInterface();
  const [scheduleId, setScheduleId] = useState('');
  const [hasSearched, setHasSearched] = useState(false);
  const [validId, setValidId] = useState<string | null>(null); 
  const [successOpen, setSuccessOpen] = useState(false);
  const [txId, setTxId] = useState<string | null>(null);


  const onSearch = async (scheduleId: string) => {
    const getScheduleByIdParams = {
      scheduleId: scheduleId
    };
    console.log(networkConfig.mainnet.mirrorNodeUrl);
    
    const getScheduleByIdResponse = await fetch(
      `${networkConfig.mainnet.mirrorNodeUrl}/api/v1/schedules/${getScheduleByIdParams.scheduleId}`
    );
    setHasSearched(true);
    
    setValidId(getScheduleByIdResponse.ok ? scheduleId : null);
  }

  return (
    <Stack alignItems="center" spacing={4}>
      <Typography variant="h4" color="white">
        Sealcoin Scheduled Transaction Signer
      </Typography>

      {walletInterface !== null && (
        <>
          <Stack direction="row" gap={2} alignItems="center">
            <TextField
              value={scheduleId}
              onChange={(e) => {
                setScheduleId(e.target.value);
                setHasSearched(false);
              }}
              label="Transaction ID"
            />
            <Button
              variant="contained"
              disabled={scheduleId.length === 0}
              onClick={() => onSearch(scheduleId)}
            >
              <SearchIcon />
            </Button>
          </Stack>

          <Stack>
            {/* Only show "Wrong ID!" if we've searched AND not found */}
            {hasSearched && !validId && (
              <Typography color="error">Wrong ID!</Typography>
            )}
          </Stack>

          <Stack>
            <Button
              variant="contained"
              disabled={!validId}
              onClick={async () => {
                const txId = await walletInterface.signScheduleTransction(scheduleId);
                console.log(txId);
                if (txId) {
                  setTxId(txId.toString());
                  setSuccessOpen(true);
                }
              }}
            >
              Sign <DrawIcon />
            </Button>
          </Stack>
        </>
      )}
      <Dialog
        open={successOpen}
        onClose={() => setSuccessOpen(false)}
      >
        <DialogTitle>✅ Transaction Signed</DialogTitle>
        <DialogContent>
          <Typography>
            Your transaction was successfully signed!
          </Typography>
          {txId && (
            <Typography sx={{ mt: 1, fontSize: "0.9rem", color: "gray" }}>
              Transaction ID: <strong>{txId}</strong>
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSuccessOpen(false)} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Stack>
  );
}
